import type { AppAction } from '../../types/app.types';
export type UpdateBanner = {
  type: 'notifications/UPDATE_BANNER';
  text: string | null | undefined;
};
export type NotificationAction = UpdateBanner;
export type NotificationState = {
  bannerText: string | null | undefined;
};
const initialState: NotificationState = {
  bannerText: null,
};
export function updateBanner(text: string | null | undefined): UpdateBanner {
  return {
    type: 'notifications/UPDATE_BANNER',
    text: text,
  };
}
export default function notificationReducer(
  state: NotificationState = initialState,
  action: AppAction
): NotificationState {
  switch (action.type) {
    case 'notifications/UPDATE_BANNER':
      return {
        bannerText: action.text,
      };

    case 'cart/PURCHASE_SUCCESS':
      return {
        bannerText: null,
      };

    case 'account/GET_SUMMARY_SUCCESS':
      if (action.data && action.data.stats && action.data.stats.orderCount > 0) {
        // clear banner for purchasers
        return {
          bannerText: null,
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
